import { Button, Card, Col, Flex, Form, InputNumber, Row, Typography } from 'antd';
import { FC, memo } from 'react';
import { PlusCircle, Trash } from 'react-bootstrap-icons';

import { MAX_SCREEN_DIMENSIONS, PagesCriticalCssSettingsInputs, } from '@/modules/Pages/pagesCriticalCss.interfaces';

import { screenDimensionHeightRules, screenDimensionsRules, screenDimensionWidthRules } from './validation';

const { Text } = Typography;

interface Props {
  disabled?: boolean;
}

export const PagesCriticalCssScreenDimensionsList: FC<Props> = memo(({ disabled = false }) => (
  <Form.List name={PagesCriticalCssSettingsInputs.ScreenDimensions} rules={screenDimensionsRules}>
    {(fields, { add, remove }, { errors }) => (
      <Card
        size="small"
        title={<Typography.Text>Керування розмірами екрана</Typography.Text>}
        extra={
          <Button
            type="dashed"
            size="small"
            icon={<PlusCircle/>}
            disabled={disabled || fields.length >= MAX_SCREEN_DIMENSIONS}
            onClick={() => add()}
          >
            Додати розмір
          </Button>
        }
      >
        <Flex vertical gap={8}>
          <Row>
            <Col flex="auto">
              <Text type="secondary">Ширина <Text italic type="secondary"><sup>(px)</sup></Text></Text>
            </Col>
            <Col flex="auto">
              <Text type="secondary">Висота <Text italic type="secondary"><sup>(px)</sup></Text></Text>
            </Col>
            <Col flex="40px"></Col>
          </Row>

          {fields.map(({ key, name, ...restField }) => (
            <Row key={key} gutter={8} align="top">
              <Col flex="auto">
                <Form.Item
                  {...restField}
                  name={[name, 'width']}
                  rules={screenDimensionWidthRules}
                  style={{ marginBottom: 0 }}
                >
                  <InputNumber min={1} style={{ width: '100%' }} placeholder="Ширина" />
                </Form.Item>
              </Col>

              <Col flex="auto">
                <Form.Item
                  {...restField}
                  name={[name, 'height']}
                  rules={screenDimensionHeightRules}
                  style={{ marginBottom: 0 }}
                >
                  <InputNumber min={1} style={{ width: '100%' }} placeholder="Висота" />
                </Form.Item>
              </Col>

              <Col>
                <Button type="text" danger icon={<Trash size={16} />} onClick={() => remove(name)} />
              </Col>
            </Row>
          ))}
        </Flex>

        <Form.ErrorList errors={errors} />
      </Card>
    )}
  </Form.List>
));
